import { Document } from 'docx';
import { Bareme } from 'src/types/bareme.type';
import { MonetaryErosion } from 'src/types/monetaryErosion.type';
import { Prejudice, PrejudiceType } from 'src/types/prejudice.type';
import { Procedure } from 'src/types/procedure.type';
import { Victime } from 'src/types/victime.type';
import { VictimeIndirecte } from 'src/types/victimeIndirecte.type';
import { getPGPFReliquatAndPGPFReliquatActivationStatus } from '../../prejudices/pgpfReliquat';
import { getPrejudiceTotal, PrejudiceTotalValue } from '../../prejudices/total';
import { getCGAULinkPrint, getCGAUText, getCGAUTitle } from '../CGAUPrint';
import { defaultNumberingConfigs, getEmptyLine } from '../docxFunctions';
import {
  getBordereauTitle,
  getPrejudiceNumeroPiece,
} from '../numeroPiecesPrint';
import { makePrejudiceWrittenPrint } from './prejudice.written.print';

export const makeSinglePrejudiceWrittenPrint = ({
  victime,
  procedure,
  monetaryErosions,
  prejudices,
  baremes,
  victimesIndirectes,
  prejudice,
}: {
  victime: Victime;
  procedure: Procedure;
  monetaryErosions: MonetaryErosion[];
  prejudices: Prejudice[];
  baremes: Bareme[];
  victimesIndirectes: VictimeIndirecte[];
  prejudice: Pick<Prejudice, '_id' | 'formData' | 'type' | 'formType'>;
}): Document => {
  const PGPFReliquat =
    getPGPFReliquatAndPGPFReliquatActivationStatus(prejudices);
  const prejudicesTotalValues: Partial<
    Record<PrejudiceType, PrejudiceTotalValue[]>
  > = prejudices
    .filter(({ type }) => type !== prejudice.type)
    .reduce(
      (totalPerPrejudice, prejudice) => ({
        ...totalPerPrejudice,
        [prejudice.type]: getPrejudiceTotal({
          victime,
          victimesIndirectes,
          procedure,
          prejudice,
          dateLiquidation: procedure.dateLiquidation
            ? new Date(procedure.dateLiquidation)
            : undefined,
          monetaryErosions,
          PGPFReliquat,
          dateConsolidation: procedure.dateConsolidation
            ? new Date(procedure.dateConsolidation)
            : undefined,
          dateDeces: victime.dateDeces
            ? new Date(victime.dateDeces)
            : undefined,
        }),
      }),
      {},
    );
  const prejudicePrint = makePrejudiceWrittenPrint({
    prejudice,
    procedure,
    victime,
    victimesIndirectes,
    monetaryErosions,
    baremes,
    PGPFReliquat,
    prejudicesTotalValues,
  });

  return new Document({
    numbering: {
      config: defaultNumberingConfigs,
    },
    sections: [
      { children: prejudicePrint ?? [] },
      {
        children: [
          getBordereauTitle(),
          getEmptyLine(),
          ...(getPrejudiceNumeroPiece(prejudice) ?? []),
        ],
      },
      {
        children: [
          getCGAUTitle(),
          getEmptyLine(),
          getCGAUText(),
          getEmptyLine(),
          getCGAULinkPrint(),
        ],
      },
    ],
  });
};
